function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "kvp-track_svg__a",
  x1: "0%",
  x2: "100%",
  y1: "55.339%",
  y2: "55.339%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#00907F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#48D59F"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#E6E6E6",
  strokeLinejoin: "round",
  strokeWidth: 8,
  d: "M4 93.254h57.621V17H4z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#E6E6E6",
  strokeLinecap: "square",
  strokeLinejoin: "round",
  strokeWidth: 8,
  d: "M74.621 80.254V4H17"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#E6E6E6",
  strokeWidth: 4,
  d: "M24.008 30.362h19.298M24.008 39.41h27.466M24.008 50.46h19.298m-19.298 8.047h24.606M24.008 70.558h27.466m-27.466 8.047h19.298"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#E6E6E6",
  strokeWidth: 8,
  d: "M20.423 32.084h-8m8 20.098h-8m8 20.098h-8"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#kvp-track_svg__a)",
  strokeLinejoin: "round",
  strokeWidth: 8,
  d: "M34.896 57.468L48.318 70.89l27.329-27.329",
  transform: "translate(4 4)"
}));

function SvgKvpTrack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 83 98"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA4MyA5OCI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJhIiB4MT0iMCUiIHgyPSIxMDAlIiB5MT0iNTUuMzM5JSIgeTI9IjU1LjMzOSUiPjxzdG9wIG9mZnNldD0iMCUiIHN0b3AtY29sb3I9IiMwMDkwN0YiLz48c3RvcCBvZmZzZXQ9IjEwMCUiIHN0b3AtY29sb3I9IiM0OEQ1OUYiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIHN0cm9rZT0iI0U2RTZFNiIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSI4IiBkPSJNNCA5My4yNTRoNTcuNjIxVjE3SDR6Ii8+PHBhdGggc3Ryb2tlPSIjRTZFNkU2IiBzdHJva2UtbGluZWNhcD0ic3F1YXJlIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjgiIGQ9Ik03NC42MjEgODAuMjU0VjRIMTciLz48cGF0aCBzdHJva2U9IiNFNkU2RTYiIHN0cm9rZS13aWR0aD0iNCIgZD0iTTI0LjAwOCAzMC4zNjJoMTkuMjk4TTI0LjAwOCAzOS40MWgyNy40NjZNMjQuMDA4IDUwLjQ2aDE5LjI5OE0yNC4wMDggNTguNTA3aDI0LjYwNk0yNC4wMDggNzAuNTU4aDI3LjQ2Nk0yNC4wMDggNzguNjA1aDE5LjI5OCIvPjxwYXRoIHN0cm9rZT0iI0U2RTZFNiIgc3Ryb2tlLXdpZHRoPSI4IiBkPSJNMjAuNDIzIDMyLjA4NGgtOE0yMC40MjMgNTIuMTgyaC04TTIwLjQyMyA3Mi4yOGgtOCIvPjxwYXRoIHN0cm9rZT0idXJsKCNhKSIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSI4IiBkPSJNMzQuODk2IDU3LjQ2OEw0OC4zMTggNzAuODlsMjcuMzI5LTI3LjMyOSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNCA0KSIvPjwvZz48L3N2Zz4K";
export { SvgKvpTrack as ReactComponent };